import { LastLoginDefaultBox } from "./last-login.default.box";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { LastLoginSiBox } from "./last-login.si.box";

export const LastLoginBox = styledByTheme(LastLoginDefaultBox)
    .forSI(LastLoginSiBox)
    .forSICis(LastLoginSiBox)
    .apply();
